import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SmConfirmationDialogHostComponent} from './sm-confirmation-dialog-host.component';
import {SmConfirmationDialogModule} from './sm-confirmation-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SmConfirmationDialogModule,
  ],
  declarations: [SmConfirmationDialogHostComponent],
  exports: [SmConfirmationDialogHostComponent],
})
export class SmConfirmationDialogHostModule {}
